
import React, {FC} from 'react'
import { Segment, Grid } from 'semantic-ui-react'
import { LKDate } from 'loankeeper-common/helpers/Date'
import { LKHeader } from 'loankeeper-common/components'
//@ts-ignore
import { Container, SegmentGroup, GridContainer, FakeInput } from 'shared/StyledComponents'
import { translateBase, icon } from '../helpers'
import { ClientDetailsTabProps } from '../types'
const General: FC<ClientDetailsTabProps> = ({data}) => (
  <Container>
    <SegmentGroup>
      <Segment.Group>
        <Segment>
          <GridContainer>
            <Grid columns={6}>
              <Grid.Row>
                <Grid.Column textAlign="right" verticalAlign="middle">
                  <LKHeader size="small">{translateBase('lbl_org_fullname_t')}</LKHeader>
                </Grid.Column>

                <Grid.Column style={{ width: '50%' }}>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">
                        <strong>{data.FullName}</strong>
                      </LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>

                <Grid.Column textAlign="right" verticalAlign="middle">
                  {translateBase('lbl_org_ownername_t')}
                </Grid.Column>

                <Grid.Column>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">{data.Owner}</LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>
              </Grid.Row>

              <Grid.Row>
                <Grid.Column textAlign="right" verticalAlign="middle">
                  {translateBase('lbl_org_legalstatus_t')}
                </Grid.Column>

                <Grid.Column>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">{data.LegalStatus}</LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>

                <Grid.Column textAlign="right" verticalAlign="middle">
                  {translateBase('lbl_org_ownerstatus_t')}
                </Grid.Column>

                <Grid.Column>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">{data.OwnerStatus}</LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>

                <Grid.Column textAlign="right" verticalAlign="middle">
                  <LKHeader size="small">{translateBase('lbl_org_regid_t')}</LKHeader>
                </Grid.Column>

                <Grid.Column>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">
                        <strong>{data.CardNumber}</strong>
                      </LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </GridContainer>
        </Segment>

        <Segment>
          <GridContainer>
            <Grid columns={6}>
              <Grid.Row>
                <Grid.Column textAlign="right" verticalAlign="middle">
                  {translateBase('lbl_busness_type_t')}
                </Grid.Column>

                <Grid.Column>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">{data.BusinessType}</LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>

                <Grid.Column textAlign="right" verticalAlign="middle">
                  {translateBase('lbl_org_regdate_t')}
                </Grid.Column>

                <Grid.Column>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">{LKDate.from(data.ORG_RegDate).toString()}</LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>

                <Grid.Column textAlign="right" verticalAlign="middle">
                  {translateBase('lbl_fininst_t')}
                </Grid.Column>

                <Grid.Column>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">{data.FinancialInstitution}</LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>
              </Grid.Row>

              <Grid.Row>
                <Grid.Column textAlign="right" verticalAlign="middle">
                  {translateBase('lbl_org_industry_t')}
                </Grid.Column>

                <Grid.Column>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">{data.Industry}</LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>

                <Grid.Column textAlign="right" verticalAlign="middle">
                  {translateBase('lbl_ind_risklevel_t')}
                </Grid.Column>

                <Grid.Column>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">{data.RiskLevel}</LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>

                <Grid.Column textAlign="right" verticalAlign="middle">
                  {translateBase('lbl_govrel_t')}
                </Grid.Column>

                <Grid.Column>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">{data.OwnershipType}</LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </GridContainer>
        </Segment>

        <Segment>
          <GridContainer>
            <Grid columns={6}>
              <Grid.Row>
                <Grid.Column textAlign="right" verticalAlign="middle">
                  {translateBase('lbl_org_busphone_t')}
                </Grid.Column>

                <Grid.Column>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">{data.Phone}</LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>

                <Grid.Column textAlign="right" verticalAlign="middle">
                  {translateBase('lbl_org_email_t')}
                </Grid.Column>

                <Grid.Column>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">{data.Email}</LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>

                <Grid.Column textAlign="right" verticalAlign="middle">
                  {translateBase('lbl_org_busphone2_t')}
                </Grid.Column>

                <Grid.Column>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">{data.ORG_Phone}</LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>
              </Grid.Row>

              <Grid.Row>
                <Grid.Column textAlign="right" verticalAlign="middle">
                  Client Number
                </Grid.Column>

                <Grid.Column>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">{data.CustomNum}</LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>

                <Grid.Column textAlign="right" verticalAlign="middle">
                  {translateBase('lbl_passphrase_org_t')}
                </Grid.Column>

                <Grid.Column>
                  <FakeInput>
                    <Segment>
                      {/*@ts-ignore*/}
                      <LKHeader size="small">{data.PassPhrase}</LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>

                <Grid.Column textAlign="right" verticalAlign="middle">
                  <LKHeader size="tiny">{translateBase('lbl_cell_phone_t')}</LKHeader>
                </Grid.Column>

                <Grid.Column>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">
                        <strong>{data.CellPhone}</strong>
                      </LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </GridContainer>
        </Segment>

        <Segment>
          <GridContainer>
            <Grid columns={6}>
              <Grid.Row>
                <Grid.Column textAlign="right" verticalAlign="middle">
                  {translateBase('lbl_org_address_t')}
                </Grid.Column>

                <Grid.Column style={{ width: '50%' }}>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">
                        {`${data.Address}, ${data.City}, ${data.Territory}, ${data.Region}, ${data.Country}`}
                      </LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>

                <Grid.Column textAlign="right" verticalAlign="middle">
                  {translateBase('lbl_org_fax_t')}
                </Grid.Column>

                <Grid.Column>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">{data.ORG_Fax}</LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>
              </Grid.Row>

              <Grid.Row>
                <Grid.Column textAlign="right" verticalAlign="middle">
                  {translateBase('lbl_org_address2_t')}
                </Grid.Column>

                <Grid.Column style={{ width: '50%' }}>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">
                        {`${data.AddressBus}, ${data.CityBus}, ${data.DistrictBus}, ${data.ZoneBus}, ${data.TerritoryBus}, ${data.RegionBus}, ${data.CountryBus}`}
                      </LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>

                <Grid.Column textAlign="right" verticalAlign="middle">
                  {translateBase('lbl_org_web_t')}
                </Grid.Column>

                <Grid.Column>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">{data.ORG_Web}</LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>
              </Grid.Row>

              <Grid.Row>
                <Grid.Column textAlign="right" verticalAlign="middle">
                  {translateBase('lbl_org_address_details2_t')}
                </Grid.Column>

                <Grid.Column style={{ width: '50%' }}>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">
                        {/*@ts-ignore*/}
                        {`${data.ZipCodeBus} / ${parseInt(data.DistanceBus, 10)} / ${data.UrbanBus}`}
                      </LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>

                <Grid.Column textAlign="right" verticalAlign="middle">
                  {translateBase('lbl_org_email2_t')}
                </Grid.Column>

                <Grid.Column>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">{data.Email1}</LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </GridContainer>
        </Segment>

        <Segment>
          <GridContainer>
            <Grid columns={6}>
              <Grid.Row>
                <Grid.Column textAlign="right" verticalAlign="middle">
                  {translateBase('lbl_mcl')}
                </Grid.Column>

                <Grid.Column>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">{data.MCLEnabledT}</LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>

                <Grid.Column textAlign="right" verticalAlign="middle">
                  {translateBase('lbl_org_statuslevel_t')}
                </Grid.Column>

                <Grid.Column>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">{data.StatusLevel}</LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>

                <Grid.Column textAlign="right" verticalAlign="middle">
                  {translateBase('lbl_kyc_valid_t')}
                </Grid.Column>

                <Grid.Column>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">{data.KYCValidity}</LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>
              </Grid.Row>

              <Grid.Row>
                <Grid.Column textAlign="right" verticalAlign="middle">
                  {translateBase('lbl_org_autocoverpref_t')}
                </Grid.Column>

                <Grid.Column>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">{data.AutoCoverPref}</LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>

                <Grid.Column textAlign="right" verticalAlign="middle">
                  {translateBase('lbl_org_sdaenabled_t')}
                </Grid.Column>

                <Grid.Column>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">{data.SDAEnabledT}</LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>

                <Grid.Column textAlign="right" verticalAlign="middle">
                  {translateBase('lbl_org_amlstatus_t')}
                </Grid.Column>

                <Grid.Column>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">{data.AMLStatus}</LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>
              </Grid.Row>

              <Grid.Row>
                <Grid.Column textAlign="right" verticalAlign="middle">
                  {translateBase('lbl_org_emailpref_t')}
                </Grid.Column>

                <Grid.Column>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">{data.EmailPref}</LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>

                <Grid.Column textAlign="right" verticalAlign="middle">
                  {translateBase('lbl_org_amlindustry_t')}
                </Grid.Column>

                <Grid.Column>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">{data.AMLIndustry}</LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>

                <Grid.Column textAlign="right" verticalAlign="middle">
                  {translateBase('lbl_org_amlsusp_t')}
                </Grid.Column>

                <Grid.Column>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">{data.AMLSuspicious}</LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </GridContainer>
        </Segment>

        <Segment>
          <GridContainer>
            <Grid columns={6}>
              <Grid.Row>
                <Grid.Column textAlign="right" verticalAlign="middle">
                  {translateBase('lbl_org_smspref_t')}
                </Grid.Column>

                <Grid.Column>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">{data.SMSPref}</LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </GridContainer>
        </Segment>
      </Segment.Group>
    </SegmentGroup>
  </Container>
)

//@ts-ignore
General.config = {
  title: () => translateBase('tb_ind_1'),
  name: 'general',
  component: General,
  api: 'base',
  icon: icon('tb_ind_1'),
}

export default General
